<template>
  <!-- A Sunday-morning game's take-or-wait call (`morningCall`), on the card
       below the win % row until kickoff. A neutral panel, not a team-colour
       one: it is advice about the slot, not about either team. -->
  <div
    v-if="call"
    class="rounded-xl border border-white/10 bg-white/[0.04] px-3 pt-2.5 pb-[11px]"
    data-test="morning-call"
  >
    <div class="flex items-center gap-1.5 text-[9px] font-extrabold tracking-[0.16em] text-slate-400">
      <svg class="h-3 w-3 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      <span>{{ call.kicker }}</span>
    </div>
    <div class="mt-1.5 flex items-baseline justify-between gap-2.5">
      <span
        class="whitespace-nowrap text-xl font-black leading-[22px] tracking-[-0.01em]"
        :style="{ color: callColor }"
      >{{ call.call }}</span>
      <span class="text-right text-xs font-semibold text-slate-300">{{ call.reason }}</span>
    </div>
    <div class="relative mt-2.5 h-[30px]" aria-hidden="true">
      <div class="absolute inset-x-0 top-[5px] h-1.5 rounded-full bg-slate-400/[0.22]"></div>
      <div
        class="absolute right-0 top-[5px] h-1.5 rounded-r-full bg-emerald-400/[0.28]"
        :style="{ left: `${call.barAt}%` }"
      ></div>
      <span
        class="absolute top-px h-3.5 w-0.5 -translate-x-1/2 bg-slate-200"
        :style="{ left: `${call.barAt}%` }"
      ></span>
      <span
        class="absolute top-4 -translate-x-1/2 whitespace-nowrap text-[9px] font-bold text-slate-300"
        :style="{ left: `${call.barAt}%` }"
      >{{ call.barLabel }}</span>
      <span
        class="absolute top-0.5 h-3 w-3 -translate-x-1/2 rounded-full"
        :style="{ left: `${call.dotAt}%`, background: callColor, boxShadow: '0 0 0 2px #071425' }"
      ></span>
    </div>
    <p class="mt-1 text-[11px] leading-[15px] text-slate-400">{{ call.note }}</p>
  </div>
</template>

<script>
import { morningCall } from "../utils/morningGame.js";

// Emerald for take, orange for wait: orange rather than yellow so it never
// reads as the yellow "Slight" strength word on the row above.
const TAKE = "#34d399";
const WAIT = "#fb923c";

// The box disappears at kickoff, so the card keeps its own clock.
const TICK_MS = 30 * 1000;

export default {
  name: "MorningCall",
  props: {
    game: { type: Object, required: true },
    edge: { type: Object, required: true },
  },
  data() {
    return { now: Date.now(), timer: null };
  },
  computed: {
    call() {
      return morningCall(this.game, this.edge, this.now);
    },
    callColor() {
      return this.call?.take ? TAKE : WAIT;
    },
  },
  mounted() {
    this.timer = setInterval(() => {
      this.now = Date.now();
    }, TICK_MS);
  },
  beforeUnmount() {
    clearInterval(this.timer);
  },
};
</script>
